import CityPage from "../CityPage";

export default function Lockport() {
  return <CityPage slug="lockport" />;
}
